import React, {useEffect, useCallback} from 'react';
import {setEffectParameterValues} from "actions/index.js";
import {isNumber} from 'utils/IsNumber.js';
import {uuid} from 'uuidv4';
import {
    INPUT,
    OUTPUT,
    } from './constants.js';
import {MIDI_FX, AUDIO_FX, OSCILLATOR} from 'constants/effect-types.js';
import {getNonOverlapping} from './overlaps.js';

export const useRackKeys = ({
    rack,
    selectedEdge,
    selectedNodes,
    setEdges,
    setEffects,
    selectedNode,
    connectEdge,
    setCopiedNodes,
    copiedNodes,
    setSelectedNodes,
    setLfoEdges,
    setEnvelopeEdges,
    getLastNode,
    setMacros,
    setMacroEdges,
    ... props
}) => {

    useEffect(() => {
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [
        selectedEdge,
        setSelectedNodes,
        selectedNode,
        setEdges,
        setEffects,
        props.isSelected,
    ]);

    const onKeyDown = useCallback((e) => {
        console.log("on key down happend presiod");
        if (rack.getEffectType() === OSCILLATOR &&
            (e.key !== 'Backspace')) {
            return;
        }

        if (e.target.tagName.toUpperCase() === 'INPUT' ||
            (rack.getEffectType() !== OSCILLATOR && rack.name !== "Rules Rack" &&
             rack.name !== "Chords Rack" && !props.isSelected)) {
            console.log('bruh input');
            //return;
        }
        e.stopPropagation();
        if (e.key === 'Backspace') {
            console.log("backspace in rack selected=", selectedNodes);
            if (selectedEdge) {
                if (rack.getEffectType() === OSCILLATOR &&
                    selectedEdge.modulator === undefined) {
                    return;
                }
                rack.deleteEdge(selectedEdge);
                setEdges({... rack.adjacencyLists});
                setLfoEdges({... rack.lfoAdjacencyLists});
                setEnvelopeEdges({... rack.envelopeAdjacencyLists});
            } else if (selectedNodes.length > 0) {
                if (rack.getEffectType() === OSCILLATOR) {
                    return;
                }
                for (let selectedNode of selectedNodes) {
                    if (rack.isMacro(selectedNode)) {
                        rack.deleteMacro(selectedNode);
                        setMacros([... rack.macros]);
                        setMacroEdges({... rack.macroAdjacencyLists});
                    } else {
                        console.log('deleting effect = ', selectedNode);
                        rack.deleteEffect(selectedNode);
                    }
                }
                props.setContextualHelp(undefined);
                setSelectedNodes([]);
                setLfoEdges({... rack.lfoAdjacencyLists});
                setEnvelopeEdges({... rack.envelopeAdjacencyLists});
                setEdges({... rack.adjacencyLists});
                setEffects([... rack.effects]);
            }
        } else if (e.key === 'l' && (e.metaKey || e.ctrlKey)) {
            let node = getLastNode(selectedNodes);
            if (node && selectedNodes[0]) {
                rack.connectNodes(node, selectedNodes[0]);
                setEdges({... rack.adjacencyLists});
            }
        } else if (e.key === 'd' && (e.metaKey || e.ctrlKey)) {
            e.preventDefault();
            e.stopPropagation();

            if (selectedNode && selectedNode.getType === undefined) {
                // it's an effect so we duplicate
                let effect = selectedNode.getEffectCopy();
                effect.id = uuid();
                rack.addEffect(effect);
                let {x, y} = getNonOverlapping(selectedNode.x, selectedNode.y, rack);
                effect.x = x;
                effect.y = y;
                setEffects([... rack.effects]);
            }
            return false;
        } else if (e.key === 'c' && (e.metaKey || e.ctrlKey)) {
            e.stopPropagation();
            e.preventDefault();
            setCopiedNodes([... selectedNodes]);
            return false;
            // copy selected nodes along with their structure
        } else if (e.key === 'v' && (e.metaKey || e.ctrlKey)) {
            // paste selected nodes along with their structure
            e.stopPropagation();
            e.preventDefault();
            rack.pasteNodes(props.sequencerEngine.state.effects.copiedNodesForRack);
            setEffects([... rack.effects]);
            setEdges({... rack.adjacencyLists});
            return false;
        } else if (e.key === 'o' && (e.metaKey || e.ctrlKey)) {
            e.stopPropagation();
            e.preventDefault();

            selectedNodes.forEach(
                node => connectEdge(node, OUTPUT, {mode: INPUT, node: rack.outputNode}));

            return false;
        } else if (e.key === 'i' && (e.metaKey || e.ctrlKey)) {
            e.stopPropagation();
            e.preventDefault();

            selectedNodes.forEach(
                node => connectEdge(node, INPUT, {mode: OUTPUT, node: rack.inputNode}));

            return false;
        } else if (e.key === '-') {
            e.stopPropagation();
            if (selectedNodes.length > 0) {
                selectedNodes.forEach(q => q.value = -q.value);
                // force dispatch
                props.sequencerEngine.dispatch(setEffectParameterValues({}));
            }
        } else if (isNumber(e.key)) {
            e.stopPropagation();
            if (selectedNodes.length > 0) {
                selectedNodes.forEach(q => q.value = parseInt(e.key));
                // force dispatch
                props.sequencerEngine.dispatch(setEffectParameterValues({}));
            }
        }
    }, [
        connectEdge,
        props.isSelected,
        setCopiedNodes,
        copiedNodes,
        selectedEdge,
        setSelectedNodes,
        selectedNodes,
        setEdges,
        setEffects,
        setLfoEdges,
        setEnvelopeEdges]);

};
